import 'application/templates/root.router';

import 'application/templates/login/login.router';

import 'application/templates/privacy-policies/privacy-policies.router';

import 'application/templates/unmark-email/unmark-email.router';

import 'application/templates/terms-conditions/terms-conditions.router';

import 'application/templates/upload-image-preview/upload-image-preview.router';

import 'application/templates/forgot-password/forgot-password.router';

import 'application/templates/reset-password/reset-password.router';

import 'application/templates/default/default.router';

import 'application/templates/default/inner/otherwise/otherwise.router';

import 'application/templates/default/inner/initial/initial.router';

import 'application/templates/default/inner/add-automatic-processes/add-automatic-processes.router';

import 'application/templates/default/inner/add-processes/add-processes.router';

import 'application/templates/default/inner/add-processes-quick-register-oab/add-processes-quick-register-oab.router';

import 'application/templates/default/inner/blocked-user/blocked-user.router';

import 'application/templates/default/inner/publications/publications.router';

import 'application/templates/default/inner/publications/inner/publications-details/publications-details.router';

import 'application/templates/default/inner/publications/inner/keywords/keywords.router';

import 'application/templates/default/inner/publications/inner/keywords/inner/keywords-details/keywords-details.router';

import 'application/templates/default/inner/movements/movements.router';

import 'application/templates/default/inner/movements/inner/list/list.router';

import 'application/templates/default/inner/movements/inner/movements-details/movements-details.router';

import 'application/templates/default/inner/movements/inner/many-details/details.router';

import 'application/templates/default/inner/movements/inner/process-list/process-list.router';

import 'application/templates/default/inner/movements/inner/keywords-list/keywords-list.router';

import 'application/templates/default/inner/movements/inss/list/inss-list.router';

import 'application/templates/default/inner/movements/inss/details/inss-details.router';

import 'application/templates/default/inner/movements/inss/manager/inss-manager.router';

import 'application/templates/default/inner/account/account.router';

import 'application/templates/default/inner/account/inner/info/info.router';

import 'application/templates/default/inner/account/inner/config/config.router';

import 'application/templates/default/inner/account/inner/plans/plans.router';

import 'application/templates/default/inner/account/inner/atendimento/atendimento.router';

import 'application/templates/default/inner/account/inner/users/users.router';

import 'application/templates/default/inner/module-people/module-people.router.js';

import 'application/templates/default/inner/module-financial/module-financial.router.js';

import 'application/templates/default/inner/module-intimations/module-intimations.router.js';

import 'application/templates/default/inner/legal-partner/legal-partner.router.js';

import 'application/templates/default/inner/module-movements/module-movements.router.js';

import 'application/templates/default/inner/module-schedule/module-schedule.router.js';
